import React from 'react';
import { Card, Space, Table, Tag, Typography } from 'antd';
import { EpcEstimateRevisionComparePanel } from './EpcEstimateRevisionComparePanel';

const { Text } = Typography;

export interface EpcEstimateRevisionsWorkbenchProps {
  estimateId: string;
  revisionId?: string | null;
  revisions: Array<{
    id: string;
    revision_label?: string;
    revision_number?: number;
    status?: string;
    commercial_usage?: string;
    created_at?: string;
  }>;
  onSelectRevision?: (id: string) => void;
}

/**
 * EST3 UX2 Wave 8 — Revisions list + compare workbench.
 */
export const EpcEstimateRevisionsWorkbench: React.FC<EpcEstimateRevisionsWorkbenchProps> = ({
  estimateId,
  revisionId,
  revisions,
  onSelectRevision,
}) => (
  <Space direction="vertical" style={{ width: '100%' }} size="middle">
    <Card size="small" title="Revisions">
      <Table
        size="small"
        rowKey="id"
        dataSource={revisions}
        pagination={revisions.length > 15 ? { pageSize: 15 } : false}
        rowSelection={
          onSelectRevision
            ? {
                type: 'radio',
                selectedRowKeys: revisionId ? [revisionId] : [],
                onChange: (keys) => onSelectRevision((keys[0] as string) || ''),
              }
            : undefined
        }
        onRow={
          onSelectRevision
            ? (row) => ({
                onClick: () => onSelectRevision(row.id),
                style: { cursor: 'pointer' },
              })
            : undefined
        }
        columns={[
          { title: 'Rev', dataIndex: 'revision_label', width: 80 },
          {
            title: 'Status',
            dataIndex: 'status',
            width: 120,
            render: (v) => <Tag>{v}</Tag>,
          },
          { title: 'Usage', dataIndex: 'commercial_usage', width: 120 },
          {
            title: 'Created',
            dataIndex: 'created_at',
            render: (v) => (v ? String(v).slice(0, 10) : '—'),
          },
        ]}
      />
      <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
        Select a revision to work in the header selector; compare any two revisions below.
      </Text>
    </Card>

    <EpcEstimateRevisionComparePanel
      estimateId={estimateId}
      revisions={revisions}
      defaultToRevisionId={revisionId}
    />
  </Space>
);
